<template>
    <div>
        <div class="fund-tile">
            <router-link :to="{ name: 'fundContent', query: { fund_id: fundId, title: fundName } }"
                class="text-decoration-none">
                <div class="fund-tile__thumbnail fund-tile__thumbnail--default rounded-lg">
                    <div class="fund-tile-thumbnail__cover rounded-lg" :style="{ backgroundImage: `url(${thumbnailUri})` }">
                    </div>
                </div>
            </router-link>
            <div class="fund-tile__body fund-tile-body">
                <router-link :to="{ name: 'fundContent', query: { fund_id: fundId, title: fundName } }"
                    class="text-decoration-none mb-auto">
                    <div class="fund-tile-body__title ellipsis1">{{ fundName }}</div>
                    <div class="fund-tile-body__lead ellipsis1 mb-1">{{ partnerName }}</div>
                    <div class="fund-tile-body__lead ellipsis2">{{ decodeText(explanationShort) }}</div>                    
                </router-link>
                <div class="small d-flex mt-1 align-center">
                    <div class="mr-auto">
                        <div class="d-flex">
                            <div v-for="count in viewCount" :key="count" style="margin:0 -1px">
                                <v-icon class="align-self-end" color="primary">mdi-account</v-icon>
                            </div>
                        </div>
                    </div>
                    <div class="unit-price mr-2">{{ formatPrice(price) }} 円</div>
                    <div v-if="!notViewWatched">
                        <v-btn :loading="isLoading" id="id-watch-icon" :class="{ 'checked': isWatched }"
                            size="small" background-color="white" :ripple="false" variant="text" icon="mdi-heart" density="compact"
                            @click="onClickedWatch">
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helper from '../assets/js/helper';
import axios from "axios"
const watchListApi = '/api/watch/item/save'
export default {
    name: 'FundTile',
    props: {
        'fundId': Number,
        'fundName': String,
        'explanationShort': String,
        'thumbnailUri': String,
        'partnerName': String,
        'price': Number,
        'supporter': Number,
        'isWatch': Boolean,
        'amount': Number,
        'totalAmount': Number,
    },
    data() {
        return {
            isWatched: false,
            isLoading: false,
            notViewWatched: false,
            calcSupporter: 0,
            viewCount: 0,
            supporterIconRate: 20,
        }
    },
    // コンポーネントマウントリスナ
    mounted() {
        this.isWatched = this.isWatch;
        this.calcSupporter = this.supporter;
        this.calcInvestors();
    },
    computed: {
    },
    watch: {
        isWatch(value) {
            this.isWatched = value;
        },
        supporter(value) {
            this.calcSupporter = value;
            this.calcInvestors();
        },
    },
    methods: {
        decodeText(text) {
            return helper.decodeHtmlEscape(text);
        },
        formatPrice(num){
            if(!num) return '-'
            return helper.addComma(num)
        },
        calcInvestors(){
            if(this.calcSupporter > 1){
                this.viewCount = Math.ceil(this.calcSupporter / this.supporterIconRate)
                if(this.viewCount > 5){
                    this.viewCount = 5;
                }
            }
        },
        onClickedWatch() {
            (async () => {
                try {
                    this.isLoading = true
                    var params = new URLSearchParams();
                    params.append('fund_id', this.fundId);
                    params.append('mode', this.isWatched ? 'del' : 'add');
                    const response = await axios.post(watchListApi, params)
                    console.log(response)
                    this.isWatched = !this.isWatched

                } catch (error) {
                    console.log(error)
                    alert('ウォッチリストの登録に失敗しました。画面右上のリロードボタンからページを更新後、再度お試しください。')
                } finally {
                    setTimeout(() => {
                        this.isLoading = false
                    }, 500);
                }
            })()
        }
    }
}
</script>

<style scoped>
.fund-tile {
    display: flex;
    gap: 10px;
    width: 100%;
    box-sizing: border-box;
}

.fund-tile__thumbnail {
    width: 100px;
    aspect-ratio: 1;
    background-color: #eee;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

.fund-tile__thumbnail--default {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-color: #aaa;
    background-image: url('../assets/images/empty.gif');
}

.fund-tile-thumbnail__cover {
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.fund-tile__body {
    width: calc(100% - 110px);
}

.fund-tile-body {
    display: flex;
    flex-flow: column;
    text-align: left;
    ;
}

.fund-tile-body__title {
    font-weight: bold;
    font-size: 0.8em;
}

.fund-tile-body__lead {
    color: #666;
    font-size: 0.75em;
}

.mdi-account.text-primary {
    font-size: 16px;
}

.unit-price {
    font-size: 14px;
    font-weight: 700;
}

#id-watch-icon {
    color: #cccccc;
}

#id-watch-icon.checked {
    color: #ff0000;
}
</style>
